// plugins/alert.ts
import { defineNuxtPlugin } from '#imports'
import { createApp } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
    const createAlert = async () => {
        const CustomAlert = await import('~/components/UI/CustomAlert.vue')
        const alertContainer = document.createElement('div')
        alertContainer.id = `alert-container-${Date.now()}`
        document.body.appendChild(alertContainer)

        const app = createApp(CustomAlert.default)
        app.component('Icon', nuxtApp.vueApp._context.components.Icon)

        const alertComponent = app.mount(`#${alertContainer.id}`) as any
        
        return {
            component: alertComponent,
            cleanup: () => {
                app.unmount()
                document.body.removeChild(alertContainer)
            }
        }
    }

    const swal = {
        fire: async (options: any) => {
            if (!process.client) return Promise.resolve()
            
            const { component, cleanup } = await createAlert()
            
            try {
                const result = await component.showAlert(options)
                return result
            } finally {
                cleanup()
            }
        },

        success: async (title: string) => {
            return swal.fire({ title, icon: 'success' })
        },

        error: async (title: string) => {
            return swal.fire({ title, icon: 'error' })
        },

        warning: async (title: string) => {
            return swal.fire({ title, icon: 'warning' })
        },

        info: async (title: string) => {
            return swal.fire({ title, icon: 'info' })
        },

        loading: async (title: string, text: string | null = null) => {
            if (!process.client) return { close: () => {} }
            
            const { component, cleanup } = await createAlert()
            
            component.showAlert({
                title,
                text,
                icon: 'loading',
                isLoading: true
            })
            
            return {
                close: () => {
                    component.closeAlert()
                    cleanup()
                }
            }
        }
    }

    return {
        provide: {
            swal
        }
    }
})